/* global __DEV__ */
import React from 'react';
import * as Sentry from '@sentry/browser';
import injectTapEventPlugin from 'react-tap-event-plugin';
import 'babel-polyfill';
import { render } from 'react-dom';
import AppWrapper from 'components/AppWrapper';

Sentry.init({dsn: "https://c20d1075df17434b89f71399034c4fdd@sentry.io/1846476", environment: process.env.NODE_ENV});

injectTapEventPlugin();
// Segment.identify();

if (__DEV__) {
  window.React = React;
}

function renderApp() {
  render(<AppWrapper />, document.getElementById('root'));
}

renderApp();

if (module.hot) {
  module.hot.accept('components/AppWrapper', () => {
    renderApp();
  });
}



// WEBPACK FOOTER //
// ./src/js/main.js